import { render, staticRenderFns } from "./TemplateLibraryGlobal.vue?vue&type=template&id=2828fc67&scoped=true&"
import script from "./TemplateLibraryGlobal.vue?vue&type=script&lang=js&"
export * from "./TemplateLibraryGlobal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLibraryGlobal.vue?vue&type=style&index=0&id=2828fc67&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2828fc67",
  null
  
)

export default component.exports